<template>
  <div class="admin-container">
    <AdminSidebar :isOpen="isSidebarOpen" :userData="currentUser" />

    <div class="main-content" :class="{ 'content-shifted': isSidebarOpen }">
      <nav class="admin-nav">
        <button class="menu-btn" @click="toggleSidebar">
          <i class="fas fa-bars"></i>
        </button>
      </nav>


      <div v-if="!isAdmin" class="admin-content" style="display: flex; justify-content: center; align-items: center; min-height: 50vh;">
        <div style="text-align: center;">
          <i class="fas fa-ban" style="font-size: 3rem; color: #e53e3e; margin-bottom: 1rem;"></i>
          <h2 style="font-size: 1.5rem; margin-bottom: 0.5rem; color: #1a202c;">Truy cập bị từ chối</h2>
          <p style="color: #4a5568;">Tài khoản nhân viên (staff) không có quyền xem trang hệ thống Email Marketing.</p>
        </div>
      </div>
      <div v-else class="admin-content">
        <div class="batch-email-container">
          <!-- Header -->
          <div class="page-header">
            <h1><i class="fas fa-envelope"></i> Gửi Email Hàng Loạt</h1>
            <div class="header-actions">
              <button
                class="tab-btn"
                :class="{ active: activeTab === 'compose' }"
                @click="activeTab = 'compose'"
              >
                <i class="fas fa-pen"></i> Soạn Email
              </button>
              <button
                class="tab-btn"
                :class="{ active: activeTab === 'history' }"
                @click="activeTab = 'history'; fetchCampaigns()"
              >
                <i class="fas fa-history"></i> Lịch Sử
              </button>
              <button
                class="tab-btn"
                :class="{ active: activeTab === 'suppression' }"
                @click="activeTab = 'suppression'; fetchSuppressions()"
              >
                <i class="fas fa-user-slash"></i> Email Chặn
              </button>
            </div>
          </div>

          <!-- COMPOSE TAB -->
          <div v-if="activeTab === 'compose'">
            <!-- Step Indicators -->
            <div class="step-indicators">
              <div
                v-for="(step, idx) in steps"
                :key="idx"
                class="step-item"
                :class="{ active: currentStep === idx, completed: currentStep > idx }"
                @click="goToStep(idx)"
              >
                <div class="step-number">
                  <i v-if="currentStep > idx" class="fas fa-check"></i>
                  <span v-else>{{ idx + 1 }}</span>
                </div>
                <span class="step-label">{{ step }}</span>
              </div>
            </div>

            <!-- STEP 0: Filter Customers -->
            <div v-if="currentStep === 0" class="step-content">
              <div class="card">
                <div class="card-header">
                  <h2><i class="fas fa-filter"></i> Lọc Khách Hàng</h2>
                </div>
                <div class="card-body">
                  <div class="filter-row">
                    <div class="filter-group">
                      <label>Từ ngày</label>
                      <input type="date" v-model="filterFromDate" class="form-input" />
                    </div>
                    <div class="filter-group">
                      <label>Đến ngày</label>
                      <input type="date" v-model="filterToDate" class="form-input" />
                    </div>
                    <div class="filter-group">
                      <label>Trạng thái</label>
                      <div class="custom-select" v-click-outside="() => showStatusDropdown = false">
                        <div class="select-trigger" @click="showStatusDropdown = !showStatusDropdown">
                          <span>
                            {{ filterStatuses.length > 0
                              ? filterStatuses.length === statusOptions.length ? 'Tất cả' : `Đã chọn ${filterStatuses.length}`
                              : 'Chọn trạng thái'
                            }}
                          </span>
                          <i class="fas fa-chevron-down"></i>
                        </div>
                        <div class="select-dropdown" v-if="showStatusDropdown">
                          <label class="select-option">
                            <input
                              type="checkbox"
                              :checked="isAllStatusesSelected"
                              @change="toggleAllStatuses"
                            />
                            <span>Tất cả</span>
                          </label>
                          <div class="dropdown-divider"></div>
                          <label
                            v-for="opt in statusOptions"
                            :key="opt.value"
                            class="select-option"
                          >
                            <input
                              type="checkbox"
                              :value="opt.value"
                              v-model="filterStatuses"
                            />
                            <span>{{ opt.label }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="filter-group filter-action">
                      <button class="primary-btn" @click="fetchCustomers" :disabled="isLoadingCustomers">
                        <i class="fas fa-search" v-if="!isLoadingCustomers"></i>
                        <i class="fas fa-spinner fa-spin" v-else></i>
                        Tìm khách hàng
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Customer List -->
              <div class="card" v-if="customers.length > 0">
                <div class="card-header">
                  <h2>
                    <i class="fas fa-users"></i>
                    Danh sách khách hàng
                    <span class="badge">{{ customers.length }}</span>
                  </h2>
                  <div class="card-actions">
                    <label class="select-all-label">
                      <input
                        type="checkbox"
                        :checked="allSelected"
                        @change="toggleSelectAll"
                      />
                      Chọn tất cả
                    </label>
                    <span class="selected-count" v-if="selectedEmails.length > 0">
                      Đã chọn: <strong>{{ selectedEmails.length }}</strong>
                    </span>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="admin-table">
                      <thead>
                        <tr>
                          <th class="col-checkbox"><input type="checkbox" :checked="allSelected" @change="toggleSelectAll" /></th>
                          <th>Email</th>
                          <th>Tên khách hàng</th>
                          <th>Số lần đặt</th>
                          <th>Lần đặt cuối</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="customer in paginatedCustomers"
                          :key="customer.email"
                          :class="{ selected: selectedEmails.includes(customer.email) }"
                        >
                          <td class="col-checkbox">
                            <input
                              type="checkbox"
                              :checked="selectedEmails.includes(customer.email)"
                              @change="toggleEmail(customer.email)"
                            />
                          </td>
                          <td class="email-cell">{{ customer.email }}</td>
                          <td>{{ customer.customer_name || '—' }}</td>
                          <td class="center">{{ customer.booking_count }}</td>
                          <td class="nowrap">{{ formatDate(customer.last_booking_date) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div class="pagination" v-if="customerTotalPages > 1">
                    <button class="pagination-btn" @click="customerPage--" :disabled="customerPage <= 1">
                      <i class="fas fa-chevron-left"></i>
                    </button>
                    <span class="page-info">{{ customerPage }} / {{ customerTotalPages }}</span>
                    <button class="pagination-btn" @click="customerPage++" :disabled="customerPage >= customerTotalPages">
                      <i class="fas fa-chevron-right"></i>
                    </button>
                  </div>

                  <div class="step-nav">
                    <div></div>
                    <button
                      class="primary-btn"
                      :disabled="selectedEmails.length === 0"
                      @click="currentStep = 1"
                    >
                      Tiếp theo: Soạn Email <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div class="card" v-else-if="hasSearched && !isLoadingCustomers">
                <div class="card-body empty-state">
                  <i class="fas fa-inbox empty-icon"></i>
                  <h3>Không tìm thấy khách hàng</h3>
                  <p>Thử thay đổi bộ lọc ngày hoặc trạng thái</p>
                </div>
              </div>
            </div>

            <!-- STEP 1: Compose Email -->
            <div v-if="currentStep === 1" class="step-content editor-step">
              <!-- Subject + Template Bar -->
              <div class="editor-top-bar">
                <div class="subject-row">
                  <div class="subject-field">
                    <label>Tiêu đề email <span class="required">*</span></label>
                    <input
                      type="text"
                      v-model="emailSubject"
                      class="form-input subject-input"
                      placeholder="VD: Khuyến mãi đặc biệt từ DCX Bus 🎉"
                      maxlength="500"
                    />
                  </div>
                  <div class="template-actions">
                    <button class="template-btn" @click="showTemplatePanel = !showTemplatePanel">
                      <i class="fas fa-bookmark"></i>
                      {{ showTemplatePanel ? 'Ẩn mẫu' : 'Chọn mẫu cũ' }}
                    </button>
                    <button class="template-btn save-template-btn" @click="saveAsTemplate">
                      <i class="fas fa-save"></i>
                      Lưu mẫu
                    </button>
                  </div>
                </div>

                <!-- Template Panel -->
                <div class="template-panel" v-if="showTemplatePanel">
                  <div class="template-panel-header">
                    <h3><i class="fas fa-layer-group"></i> Mẫu email từ chiến dịch trước</h3>
                    <button class="close-btn-sm" @click="showTemplatePanel = false">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="template-list" v-if="savedTemplates.length > 0">
                    <div
                      v-for="tpl in savedTemplates"
                      :key="tpl.campaign_id"
                      class="template-item"
                      @click="loadTemplate(tpl)"
                    >
                      <div class="template-info">
                        <strong>{{ tpl.subject }}</strong>
                        <span class="template-meta">
                          {{ formatDate(tpl.created_at) }} · {{ tpl.total_recipients }} người nhận
                        </span>
                      </div>
                      <button class="load-btn" title="Tải mẫu này">
                        <i class="fas fa-download"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else-if="isLoadingTemplates" class="template-loading">
                    <i class="fas fa-spinner fa-spin"></i> Đang tải mẫu...
                  </div>
                  <div v-else class="template-empty">
                    <i class="fas fa-inbox"></i> Chưa có mẫu email nào
                  </div>
                </div>
              </div>

              <!-- Full-height Editor -->
              <div class="editor-fullscreen">
                <div id="unlayer-editor" class="unlayer-container"></div>
              </div>

              <!-- Bottom bar -->
              <div class="editor-bottom-bar">
                <button class="secondary-btn" @click="currentStep = 0">
                  <i class="fas fa-arrow-left"></i> Quay lại
                </button>
                <button
                  class="primary-btn"
                  @click="exportAndPreview"
                  :disabled="!emailSubject"
                >
                  Xem trước & Gửi <i class="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>

            <!-- STEP 2: Review & Send -->
            <div v-if="currentStep === 2" class="step-content">
              <div class="card">
                <div class="card-header">
                  <h2><i class="fas fa-paper-plane"></i> Xem Trước & Gửi</h2>
                </div>
                <div class="card-body">
                  <!-- Summary -->
                  <div class="review-summary">
                    <div class="summary-item">
                      <i class="fas fa-envelope"></i>
                      <div>
                        <span class="summary-label">Tiêu đề</span>
                        <strong>{{ emailSubject }}</strong>
                      </div>
                    </div>
                    <div class="summary-item">
                      <i class="fas fa-users"></i>
                      <div>
                        <span class="summary-label">Số người nhận</span>
                        <strong>{{ selectedEmails.length }} email</strong>
                      </div>
                    </div>
                  </div>

                  <!-- Preview -->
                  <div class="email-preview">
                    <h3>Xem trước nội dung</h3>
                    <div class="preview-frame">
                      <iframe
                        :srcdoc="emailHtmlContent"
                        frameborder="0"
                        class="preview-iframe"
                      ></iframe>
                    </div>
                  </div>

                  <div class="step-nav">
                    <button class="secondary-btn" @click="currentStep = 1">
                      <i class="fas fa-arrow-left"></i> Quay lại chỉnh sửa
                    </button>
                    <button
                      class="send-btn"
                      @click="confirmAndSend"
                      :disabled="isSending"
                    >
                      <i class="fas fa-spinner fa-spin" v-if="isSending"></i>
                      <i class="fas fa-paper-plane" v-else></i>
                      {{ isSending ? 'Đang gửi...' : 'Gửi Email' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- HISTORY TAB -->
          <div v-if="activeTab === 'history'">
            <div class="card">
              <div class="card-header">
                <h2><i class="fas fa-history"></i> Lịch Sử Chiến Dịch</h2>
              </div>
              <div class="card-body">
                <div v-if="isLoadingCampaigns" class="loading-state">
                  <i class="fas fa-spinner fa-spin"></i> Đang tải...
                </div>

                <div v-else-if="campaigns.length === 0" class="empty-state">
                  <i class="fas fa-inbox empty-icon"></i>
                  <h3>Chưa có chiến dịch nào</h3>
                  <p>Bắt đầu soạn email đầu tiên ngay</p>
                </div>

                <div v-else class="table-responsive">
                  <table class="admin-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Tiêu đề</th>
                        <th>Người nhận</th>
                        <th>Đã gửi</th>
                        <th>Lỗi</th>
                        <th>Trạng thái</th>
                        <th>Ngày tạo</th>
                        <th>Chi tiết</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="campaign in campaigns" :key="campaign.campaign_id">
                        <td><strong>#{{ campaign.campaign_id }}</strong></td>
                        <td class="subject-cell">{{ campaign.subject }}</td>
                        <td class="center">{{ campaign.total_recipients }}</td>
                        <td class="center">
                          <span class="count-sent">{{ campaign.sent_count }}</span>
                        </td>
                        <td class="center">
                          <span class="count-failed" v-if="campaign.failed_count > 0">{{ campaign.failed_count }}</span>
                          <span v-else>0</span>
                        </td>
                        <td>
                          <span :class="['status-badge', 'status-' + campaign.status]">
                            {{ statusLabels[campaign.status] || campaign.status }}
                          </span>
                        </td>
                        <td class="nowrap">{{ formatDate(campaign.created_at) }}</td>
                        <td>
                          <div class="action-buttons">
                            <button
                              v-if="(['sending', 'failed'].includes(campaign.status) && (campaign.sent_count + campaign.failed_count < campaign.total_recipients)) || (campaign.failed_count > 0)"
                              class="action-btn resume-btn"
                              :title="campaign.failed_count > 0 && campaign.sent_count + campaign.failed_count >= campaign.total_recipients ? 'Gửi lại email thất bại' : 'Tiếp tục gửi'"
                              @click="resumeCampaign(campaign.campaign_id)"
                            >
                              <i class="fas fa-play"></i>
                            </button>
                            <button class="action-btn view-btn" @click="viewCampaignDetail(campaign.campaign_id)">
                              <i class="fas fa-eye"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- SUPPRESSION TAB -->
            <div v-if="activeTab === 'suppression'">
              <div class="card">
                <div class="card-header">
                  <h2><i class="fas fa-user-slash text-danger"></i> Thêm Email Chặn Tiếp Thị</h2>
                </div>
                <div class="card-body">
                  <div class="filter-row">
                    <div class="filter-group" style="flex: 2; min-width: 250px;">
                      <label>Email khách hàng</label>
                      <input
                        type="email"
                        v-model="newSuppressionEmail"
                        placeholder="email@example.com"
                        class="form-input"
                        @keyup.enter="addSuppression"
                      />
                    </div>
                    <div class="filter-group" style="flex: 3; min-width: 300px;">
                      <label>Lý do chặn (không bắt buộc)</label>
                      <input
                        type="text"
                        v-model="newSuppressionReason"
                        placeholder="Lý do chặn..."
                        class="form-input"
                        @keyup.enter="addSuppression"
                      />
                    </div>
                    <div class="filter-group filter-action">
                      <button class="primary-btn" @click="addSuppression" :disabled="isAddingSuppression" style="background: linear-gradient(135deg, #ef4444, #dc2626);">
                        <i class="fas fa-plus" v-if="!isAddingSuppression"></i>
                        <i class="fas fa-spinner fa-spin" v-else></i>
                        Thêm vào danh sách chặn
                      </button>
                    </div>
                  </div>
                  <div v-if="suppressionError" class="error-message" style="margin-top: 0.75rem;">
                    <i class="fas fa-exclamation-circle"></i> {{ suppressionError }}
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header">
                  <h2>
                    <i class="fas fa-user-slash"></i> Danh Sách Email Bị Chặn
                    <span class="badge" style="background: #ef4444;">{{ suppressions.length }}</span>
                  </h2>
                  <div class="card-actions">
                    <div style="position: relative; display: flex; align-items: center;">
                      <input
                        type="text"
                        v-model="suppressionSearch"
                        placeholder="Tìm kiếm email..."
                        class="form-input"
                        style="padding-left: 2rem; width: 220px;"
                        @keyup.enter="fetchSuppressions"
                      />
                      <i class="fas fa-search" style="position: absolute; left: 0.75rem; color: #94a3b8; font-size: 0.85rem;"></i>
                    </div>
                    <button class="secondary-btn" @click="fetchSuppressions" :disabled="isLoadingSuppressions">
                      <i class="fas fa-sync-alt" :class="{ 'fa-spin': isLoadingSuppressions }"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body" style="padding: 0;">
                  <div class="table-responsive">
                    <table class="admin-table">
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Lý do</th>
                          <th>Ngày chặn</th>
                          <th class="center" style="width: 120px;">Thao tác</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="s in suppressions" :key="s.id">
                          <td class="email-cell">
                            <i class="fas fa-user-slash" style="color: #ef4444; margin-right: 0.5rem;"></i>
                            {{ s.email }}
                          </td>
                          <td>{{ s.reason || '—' }}</td>
                          <td class="nowrap">{{ formatDate(s.suppressed_at) }}</td>
                          <td class="center">
                            <button
                              class="action-btn"
                              style="background: #f1f5f9; color: #475569; border-color: #cbd5e1; width: auto; padding: 0 0.75rem; display: inline-flex; align-items: center; gap: 0.25rem;"
                              @click="removeSuppression(s.id)"
                            >
                              <i class="fas fa-trash-alt"></i> Bỏ chặn
                            </button>
                          </td>
                        </tr>
                        <tr v-if="suppressions.length === 0 && !isLoadingSuppressions">
                          <td colspan="4" class="empty-state" style="padding: 3rem 1rem; text-align: center;">
                            <i class="fas fa-user-slash" style="font-size: 2.5rem; color: #cbd5e1; margin-bottom: 0.75rem; display: block;"></i>
                            <h3 style="margin: 0 0 0.25rem 0; color: #64748b;">Danh sách chặn trống</h3>
                            <p style="margin: 0; font-size: 0.85rem; color: #94a3b8;">Nhập email phía trên để ngăn nhận email tiếp thị.</p>
                          </td>
                        </tr>
                        <tr v-if="isLoadingSuppressions">
                          <td colspan="4" style="text-align: center; padding: 3rem 1rem; color: #3b82f6;">
                            <i class="fas fa-spinner fa-spin" style="font-size: 1.5rem;"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div style="background: #fffbeb; border: 1px solid #fef3c7; border-radius: 0.5rem; padding: 1rem; display: flex; gap: 0.75rem; color: #b45309; font-size: 0.875rem; margin-top: 1rem;">
                <i class="fas fa-info-circle" style="font-size: 1.1rem; margin-top: 0.1rem;"></i>
                <div>
                  <strong>Lưu ý:</strong> Email trong danh sách này sẽ tự động bị loại khỏi tệp khách hàng khi soạn chiến dịch. Bạn không cần thao tác thêm.
                </div>
              </div>
            </div>

            <!-- Campaign Detail Modal -->
            <div class="modal" v-if="showDetailModal" @click.self="showDetailModal = false">
              <div class="modal-content modal-lg">
                <div class="modal-header">
                  <h2><i class="fas fa-chart-bar"></i> Chi tiết chiến dịch #{{ campaignDetail?.campaign?.campaign_id }}</h2>
                  <button class="close-btn" @click="showDetailModal = false">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <div class="modal-body" v-if="campaignDetail">
                  <div class="detail-summary">
                    <div class="detail-stat">
                      <span class="stat-value">{{ campaignDetail.campaign.total_recipients }}</span>
                      <span class="stat-label">Tổng</span>
                    </div>
                    <div class="detail-stat sent">
                      <span class="stat-value">{{ campaignDetail.campaign.sent_count }}</span>
                      <span class="stat-label">Đã gửi</span>
                    </div>
                    <div class="detail-stat failed">
                      <span class="stat-value">{{ campaignDetail.campaign.failed_count }}</span>
                      <span class="stat-label">Lỗi</span>
                    </div>
                  </div>

                  <div class="detail-recipients">
                    <h3>Danh sách người nhận</h3>
                    <div class="table-responsive">
                      <table class="admin-table compact">
                        <thead>
                          <tr>
                            <th>Email</th>
                            <th>Tên</th>
                            <th>Trạng thái</th>
                            <th>Lỗi</th>
                            <th>Thời gian</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="r in campaignDetail.recipients" :key="r.log_id">
                            <td class="email-cell">{{ r.email }}</td>
                            <td>{{ r.customer_name || '—' }}</td>
                            <td>
                              <span :class="['status-badge', 'status-' + r.status]">
                                {{ recipientStatusLabels[r.status] || r.status }}
                              </span>
                            </td>
                            <td class="error-cell">{{ r.error_message || '—' }}</td>
                            <td class="nowrap">{{ r.sent_at ? formatDate(r.sent_at) : '—' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/plugins/axios'
import AdminSidebar from '../common/AdminSidebar.vue'
import { ToastService } from '@/services/ToastService'

const isProd = process.env.VUE_APP_IS_PROD === 'true'
const API_BASE_URL = isProd
  ? process.env.VUE_APP_BACKEND_URL_PROD
  : process.env.VUE_APP_BACKEND_URL_DEV

export default {
  name: 'AdminBatchEmail',
  components: { AdminSidebar },
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  data () {
    return {
      isAdmin: true,
      isSidebarOpen: false,
      currentUser: { full_name: 'Admin User', role: 'Administrator' },

      // Password protection
      isEmailUnlocked: true,
      activeTab: 'compose',
      currentStep: 0,
      steps: ['Lọc khách hàng', 'Soạn email', 'Xem trước & Gửi'],

      // Filter
      filterFromDate: '',
      filterToDate: '',
      filterStatuses: [],
      showStatusDropdown: false,
      statusOptions: [
        { value: 'confirmed', label: 'Đã xác nhận' },
        { value: 'paid', label: 'Đã thanh toán' },
        { value: 'pending', label: 'Đang chờ' },
        { value: 'canceled', label: 'Đã hủy' }
      ],
      isLoadingCustomers: false,
      hasSearched: false,
      customers: [],
      selectedEmails: [],
      customerPage: 1,
      customerPerPage: 15,

      // Editor
      emailSubject: '',
      emailHtmlContent: '',
      emailJsonDesign: null,
      unlayerEditor: null,
      showTemplatePanel: false,
      savedTemplates: [],
      isLoadingTemplates: false,

      // Send
      isSending: false,

      // History
      campaigns: [],
      isLoadingCampaigns: false,
      showDetailModal: false,
      campaignDetail: null,

      statusLabels: {
        draft: 'Nháp',
        sending: 'Đang gửi',
        completed: 'Hoàn thành',
        failed: 'Lỗi'
      },
      recipientStatusLabels: {
        pending: 'Đang chờ',
        sent: 'Đã gửi',
        failed: 'Lỗi'
      },

      // Suppressions
      suppressions: [],
      isLoadingSuppressions: false,
      suppressionSearch: '',
      newSuppressionEmail: '',
      newSuppressionReason: '',
      isAddingSuppression: false,
      suppressionError: ''
    }
  },

  computed: {
    allSelected () {
      return this.customers.length > 0 && this.selectedEmails.length === this.customers.length
    },
    customerTotalPages () {
      return Math.ceil(this.customers.length / this.customerPerPage)
    },
    isAllStatusesSelected () {
      return this.filterStatuses.length === this.statusOptions.length
    },
    paginatedCustomers () {
      const start = (this.customerPage - 1) * this.customerPerPage
      return this.customers.slice(start, start + this.customerPerPage)
    }
  },

  watch: {
    currentStep (val) {
      if (val === 1) {
        this.$nextTick(() => this.initUnlayer())
      }
    },
    showTemplatePanel (val) {
      if (val && this.savedTemplates.length === 0) {
        this.fetchTemplates()
      }
    }
  },

  mounted () {
    this.checkAuth()
    this.checkRole()
    const sidebarState = localStorage.getItem('sidebarOpen')
    if (sidebarState !== null) this.isSidebarOpen = sidebarState === 'true'
  },

  methods: {
    toggleSidebar () {
      this.isSidebarOpen = !this.isSidebarOpen
      localStorage.setItem('sidebarOpen', this.isSidebarOpen)
    },

    checkRole() {
      try {
        const token = localStorage.getItem('adminToken')
        if (!token) return
        const payload = JSON.parse(atob(token.split('.')[1]))
        this.isAdmin = payload.role === 'admin'
      } catch (e) {
        this.isAdmin = false
      }
    },

    getHeaders () {
      const token = localStorage.getItem('adminToken')
      return { Authorization: `Bearer ${token}` }
    },

    formatDate (dateString) {
      if (!dateString) return '—'
      const d = new Date(dateString)
      return d.toLocaleDateString('vi-VN', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      })
    },

    goToStep (idx) {
      if (idx < this.currentStep) this.currentStep = idx
    },

    // ---- STEP 0: Fetch Customers ----
    async fetchCustomers () {
      this.isLoadingCustomers = true
      this.hasSearched = true
      this.customerPage = 1
      try {
        const params = {}
        if (this.filterFromDate) params.from_date = this.filterFromDate
        if (this.filterToDate) params.to_date = this.filterToDate
        if (this.filterStatuses.length > 0) params.booking_status = this.filterStatuses.join(',')

        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/batch-email/customers/`,
          { headers: this.getHeaders(), params }
        )
        this.customers = res.data.customers || []
        this.selectedEmails = []
      } catch (e) {
        console.error('Failed to fetch customers:', e)
        ToastService.error('Không thể tải danh sách khách hàng')
      } finally {
        this.isLoadingCustomers = false
      }
    },

    toggleSelectAll () {
      if (this.allSelected) {
        this.selectedEmails = []
      } else {
        this.selectedEmails = this.customers.map(c => c.email)
      }
    },

    toggleEmail (email) {
      const idx = this.selectedEmails.indexOf(email)
      if (idx >= 0) {
        this.selectedEmails.splice(idx, 1)
      } else {
        this.selectedEmails.push(email)
      }
    },

    toggleAllStatuses () {
      if (this.isAllStatusesSelected) {
        this.filterStatuses = []
      } else {
        this.filterStatuses = this.statusOptions.map(o => o.value)
      }
    },

    // ---- STEP 1: Unlayer Editor ----
    initUnlayer () {
      // Ensure Unlayer script is loaded
      if (!window.unlayer) {
        const script = document.createElement('script')
        script.src = 'https://editor.unlayer.com/embed.js'
        script.onload = () => this.mountEditor()
        document.head.appendChild(script)
      } else {
        this.mountEditor()
      }
    },

    mountEditor () {
      const container = document.getElementById('unlayer-editor')
      if (!container) return

      window.unlayer.init({
        id: 'unlayer-editor',
        projectId: 1234,
        displayMode: 'email',
        locale: 'vi',
        appearance: {
          theme: 'modern_light',
          panels: {
            tools: { dock: 'right', collapsible: true }
          }
        },
        options: {
          mergeTags: {
            customer_name: { name: 'Tên khách hàng', value: '{{customer_name}}' }
          }
        },
        features: {
          textEditor: { spellChecker: false },
          preview: true
        }
      })

      this.unlayerEditor = window.unlayer

      // Restore previous design if exists
      if (this.emailJsonDesign) {
        setTimeout(() => {
          window.unlayer.loadDesign(JSON.parse(this.emailJsonDesign))
        }, 500)
      }
    },

    // ---- TEMPLATES ----
    async fetchTemplates () {
      this.isLoadingTemplates = true
      try {
        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/batch-email/campaigns/`,
          { headers: this.getHeaders(), params: { per_page: 50 } }
        )
        // Only campaigns with json_design are usable as templates
        this.savedTemplates = (res.data.items || []).filter(c => c.json_design || c.status === 'completed')
      } catch (e) {
        console.error('Failed to fetch templates:', e)
      } finally {
        this.isLoadingTemplates = false
      }
    },

    async loadTemplate (tpl) {
      try {
        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/batch-email/campaigns/${tpl.campaign_id}/`,
          { headers: this.getHeaders() }
        )
        const campaign = res.data.campaign
        if (campaign.json_design && window.unlayer) {
          window.unlayer.loadDesign(JSON.parse(campaign.json_design))
          this.emailSubject = campaign.subject
          this.showTemplatePanel = false
          ToastService.success(`Đã tải mẫu "${campaign.subject}"`)
        } else {
          ToastService.error('Mẫu này không có dữ liệu thiết kế')
        }
      } catch (e) {
        console.error('Failed to load template:', e)
        ToastService.error('Không thể tải mẫu')
      }
    },

    saveAsTemplate () {
      if (!window.unlayer) return
      window.unlayer.exportHtml((data) => {
        const name = prompt('Đặt tên cho mẫu:', this.emailSubject || 'Mẫu email mới')
        if (!name) return

        // Save locally in localStorage as a quick template store
        const templates = JSON.parse(localStorage.getItem('emailTemplates') || '[]')
        templates.unshift({
          name,
          subject: this.emailSubject,
          json_design: JSON.stringify(data.design),
          created_at: new Date().toISOString()
        })
        // Keep max 20 templates
        if (templates.length > 20) templates.length = 20
        localStorage.setItem('emailTemplates', JSON.stringify(templates))
        ToastService.success(`Đã lưu mẫu "${name}"`)
      })
    },

    exportAndPreview () {
      if (!window.unlayer) {
        ToastService.error('Trình soạn thảo chưa sẵn sàng')
        return
      }

      window.unlayer.exportHtml((data) => {
        this.emailHtmlContent = data.html
        this.emailJsonDesign = JSON.stringify(data.design)
        this.currentStep = 2
      })
    },

    // ---- STEP 2: Send ----
    async confirmAndSend () {
      const count = this.selectedEmails.length
      if (!confirm(`Bạn có chắc muốn gửi email đến ${count} người nhận?`)) return

      this.isSending = true
      try {
        const res = await axiosInstance.post(
          `${API_BASE_URL}/admin/batch-email/send/`,
          {
            subject: this.emailSubject,
            html_content: this.emailHtmlContent,
            json_design: this.emailJsonDesign,
            recipient_emails: this.selectedEmails
          },
          { headers: this.getHeaders() }
        )

        ToastService.success(res.data.message || `Đã bắt đầu gửi email đến ${count} người`)

        // Reset state
        this.currentStep = 0
        this.selectedEmails = []
        this.emailSubject = ''
        this.emailHtmlContent = ''
        this.emailJsonDesign = null
        this.unlayerEditor = null
        this.activeTab = 'history'
        this.fetchCampaigns()
      } catch (e) {
        console.error('Failed to send batch email:', e)
        const msg = e.response?.data?.detail || 'Không thể gửi email. Thử lại sau.'
        ToastService.error(msg)
      } finally {
        this.isSending = false
      }
    },

    // ---- HISTORY ----
    async fetchCampaigns () {
      this.isLoadingCampaigns = true
      try {
        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/batch-email/campaigns/`,
          { headers: this.getHeaders() }
        )
        this.campaigns = res.data.items || []
      } catch (e) {
        console.error('Failed to fetch campaigns:', e)
        ToastService.error('Không thể tải lịch sử chiến dịch')
      } finally {
        this.isLoadingCampaigns = false
      }
    },

    async viewCampaignDetail (campaignId) {
      try {
        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/batch-email/campaigns/${campaignId}/`,
          { headers: this.getHeaders() }
        )
        this.campaignDetail = res.data
        this.showDetailModal = true
      } catch (e) {
        console.error('Failed to fetch campaign detail:', e)
        ToastService.error('Không thể tải chi tiết chiến dịch')
      }
    },

    async resumeCampaign (campaignId) {
      if (!confirm('Bạn có chắc muốn tiếp tục gửi chiến dịch này?')) return

      try {
        const res = await axiosInstance.post(
          `${API_BASE_URL}/admin/batch-email/campaigns/${campaignId}/retry`,
          {},
          { headers: this.getHeaders() }
        )
        ToastService.success(res.data.message)
        this.fetchCampaigns() // Refresh list
      } catch (e) {
        console.error('Failed to resume campaign:', e)
        const msg = e.response?.data?.detail || 'Không thể tiếp tục gửi'
        ToastService.error(msg)
      }
    },

    // ---- SUPPRESSIONS ----
    async fetchSuppressions () {
      this.isLoadingSuppressions = true
      this.suppressionError = ''
      try {
        const params = { is_active: true }
        if (this.suppressionSearch) {
          params.search = this.suppressionSearch.trim().toLowerCase()
        }
        const res = await axiosInstance.get(
          `${API_BASE_URL}/admin/marketing-suppressions/`,
          { headers: this.getHeaders(), params }
        )
        this.suppressions = res.data || []
      } catch (e) {
        console.error('Failed to fetch suppressions:', e)
        ToastService.error('Không thể tải danh sách email bị chặn')
      } finally {
        this.isLoadingSuppressions = false
      }
    },

    async addSuppression () {
      this.suppressionError = ''
      const email = this.newSuppressionEmail.trim()
      if (!email || !email.includes('@')) {
        this.suppressionError = 'Vui lòng nhập email hợp lệ'
        return
      }
      this.isAddingSuppression = true
      try {
        await axiosInstance.post(
          `${API_BASE_URL}/admin/marketing-suppressions/`,
          {
            email: email,
            reason: this.newSuppressionReason.trim()
          },
          { headers: this.getHeaders() }
        )
        this.newSuppressionEmail = ''
        this.newSuppressionReason = ''
        ToastService.success('Đã thêm email vào danh sách chặn')
        this.fetchSuppressions()
      } catch (e) {
        console.error('Failed to add suppression:', e)
        const msg = e.response?.data?.detail || 'Không thể thêm email vào danh sách chặn'
        this.suppressionError = msg
        ToastService.error(msg)
      } finally {
        this.isAddingSuppression = false
      }
    },

    async removeSuppression (id) {
      if (!confirm('Bạn có chắc muốn bỏ chặn email này?')) return
      try {
        await axiosInstance.delete(
          `${API_BASE_URL}/admin/marketing-suppressions/${id}`,
          { headers: this.getHeaders() }
        )
        ToastService.success('Đã bỏ chặn email thành công')
        this.fetchSuppressions()
      } catch (e) {
        console.error('Failed to remove suppression:', e)
        ToastService.error('Không thể bỏ chặn email')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/admin.scss';
@import '@/assets/styles/admin-table.scss';

/* Password Overlay */
.password-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.password-prompt {
  background: #fff;
  border-radius: 1rem;
  padding: 2.5rem;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }

  p {
    color: #64748b;
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
}

.password-input {
  display: flex;
  gap: 0.625rem;
  margin-bottom: 0.75rem;

  input {
    flex: 1;
    padding: 0.625rem 1rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 0.5rem;
    font-size: 0.9rem;
    outline: none;
    transition: border-color 0.2s;

    &:focus { border-color: #3b82f6; }
  }

  button {
    padding: 0.625rem 1.25rem;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.2s;

    &:hover { opacity: 0.9; }
  }
}

.error-message {
  color: #ef4444;
  font-size: 0.85rem;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.batch-email-container {
  padding: 1.5rem;
}

/* Page Header */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;

  h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i { color: #3b82f6; }
  }
}

.header-actions {
  display: flex;
  gap: 0.5rem;
}

.tab-btn {
  padding: 0.625rem 1.25rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover { background: #e2e8f0; }
  &.active {
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
    border-color: transparent;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  }
}

/* Step Indicators */
.step-indicators {
  display: flex;
  gap: 0;
  margin-bottom: 2rem;
  background: #f8fafc;
  border-radius: 0.75rem;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
}

.step-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;

  &.active {
    background: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);

    .step-number {
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      color: white;
    }
    .step-label { color: #1e293b; font-weight: 600; }
  }

  &.completed {
    .step-number {
      background: #22c55e;
      color: white;
    }
    .step-label { color: #16a34a; }
  }
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 0.375rem;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &.view-btn {
    background: white;
    color: #64748b;
    &:hover { background: #f1f5f9; color: #3b82f6; border-color: #3b82f6; }
  }

  &.resume-btn {
    background: #eff6ff;
    color: #3b82f6;
    border-color: #bfdbfe;
    &:hover { background: #3b82f6; color: white; }
  }
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  color: #64748b;
  flex-shrink: 0;
}

.step-label {
  font-size: 0.875rem;
  color: #64748b;
}

/* Cards */
.card {
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  overflow: visible !important;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.card-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  border-radius: 0.75rem 0.75rem 0 0;

  h2 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i { color: #3b82f6; }
  }
}

.card-body {
  padding: 1.5rem;
  overflow: visible;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.badge {
  background: #3b82f6;
  color: white;
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  margin-left: 0.5rem;
}

/* Filter */
.filter-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: flex-end;
}

.filter-group {
  flex: 1;
  min-width: 180px;

  label {
    display: block;
    margin-bottom: 0.375rem;
    font-weight: 500;
    font-size: 0.85rem;
    color: #475569;
  }

  &.filter-action {
    flex: 0 0 auto;
  }
}

.form-input {
  width: 100%;
  padding: 0.625rem 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }
}

/* Buttons */
.primary-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

.secondary-btn {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;

  &:hover { background: #e2e8f0; }
}

.send-btn {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;

  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 16px rgba(34, 197, 94, 0.35); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}

/* Table Enhancements */
.col-checkbox { width: 40px; text-align: center; }
.center { text-align: center; }
.nowrap { white-space: nowrap; }
.email-cell { font-family: monospace; font-size: 0.85rem; }
.subject-cell { max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.error-cell { max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 0.8rem; color: #dc2626; }

tr.selected { background: #eff6ff !important; }

.select-all-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  color: #475569;
  font-weight: 500;

  input { cursor: pointer; }
}

.selected-count {
  font-size: 0.85rem;
  color: #3b82f6;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
}

.pagination-btn {
  padding: 0.375rem 0.75rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) { background: #f1f5f9; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
}

.page-info { font-size: 0.85rem; color: #64748b; }

/* Step Navigation */
.step-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}

/* Custom Select */
.custom-select {
  position: relative;
  width: 100%;
}

.select-trigger {
  padding: 0.625rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
  color: #334155;

  &:hover { border-color: #cbd5e1; }
}

.select-dropdown {
  position: absolute;
  top: 105%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 50;
  max-height: 250px;
  overflow-y: auto;
  padding: 0.5rem 0;
}

.select-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 1rem;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.9rem;
  color: #334155;
  user-select: none;

  &:hover { background: #f1f5f9; }

  input {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}

.dropdown-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.375rem 0;
}

/* Editor Step — Full Height Layout */
.editor-step {
  display: flex;
  flex-direction: column;
}

.editor-top-bar {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem 0.75rem 0 0;
  padding: 1rem 1.25rem;
}

.subject-row {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

.subject-field {
  flex: 1;
  min-width: 300px;

  label {
    display: block;
    margin-bottom: 0.375rem;
    font-weight: 600;
    color: #374151;
    font-size: 0.9rem;
  }
}

.subject-input {
  font-size: 1rem;
  padding: 0.75rem 1rem;
}

.required { color: #dc2626; }

.template-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.template-btn {
  padding: 0.625rem 1rem;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.825rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  white-space: nowrap;

  &:hover { background: #e2e8f0; }

  &.save-template-btn {
    background: #f0fdf4;
    border-color: #bbf7d0;
    color: #16a34a;

    &:hover { background: #dcfce7; }
  }
}

/* Template Panel */
.template-panel {
  margin-top: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; max-height: 0; }
  to { opacity: 1; max-height: 400px; }
}

.template-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: white;

  h3 {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i { color: #8b5cf6; }
  }
}

.close-btn-sm {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0.25rem;
  font-size: 1rem;

  &:hover { color: #475569; }
}

.template-list {
  max-height: 250px;
  overflow-y: auto;
  padding: 0.5rem;
}

.template-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;

  &:hover {
    background: white;
    border-color: #3b82f6;
    box-shadow: 0 1px 4px rgba(59, 130, 246, 0.1);
  }
}

.template-info {
  flex: 1;

  strong {
    display: block;
    font-size: 0.875rem;
    color: #1e293b;
    margin-bottom: 0.125rem;
  }
}

.template-meta {
  font-size: 0.75rem;
  color: #94a3b8;
}

.load-btn {
  background: none;
  border: 1px solid #e2e8f0;
  color: #3b82f6;
  padding: 0.375rem 0.625rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s;

  &:hover { background: #eff6ff; border-color: #3b82f6; }
}

.template-loading, .template-empty {
  text-align: center;
  padding: 1.5rem;
  color: #94a3b8;
  font-size: 0.85rem;

  i { margin-right: 0.375rem; }
}

/* Full-height Editor */
.editor-fullscreen {
  flex: 1;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  background: #f1f5f9;
}

.unlayer-container {
  height: calc(100vh - 280px);
  min-height: 700px;
  width: 100%;
}

.editor-bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0 0 0.75rem 0.75rem;
}

/* Form Group (used elsewhere) */
.form-group {
  margin-bottom: 1.25rem;

  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #374151;
    font-size: 0.9rem;
  }
}

/* Review & Preview */
.review-summary {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.summary-item {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;

  > i {
    font-size: 1.5rem;
    color: #3b82f6;
    width: 40px;
    height: 40px;
    background: #eff6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
  }

  .summary-label {
    display: block;
    font-size: 0.8rem;
    color: #64748b;
    margin-bottom: 0.125rem;
  }

  strong { color: #1e293b; font-size: 1rem; }
}

.email-preview {
  h3 {
    font-size: 1rem;
    color: #1e293b;
    margin-bottom: 0.75rem;
  }
}

.preview-frame {
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  overflow: hidden;
  background: white;
}

.preview-iframe {
  width: 100%;
  height: 500px;
  border: none;
}

/* Status Badges */
.status-badge {
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-block;

  &.status-draft { background: #f1f5f9; color: #64748b; }
  &.status-sending { background: #fef3c7; color: #d97706; }
  &.status-completed { background: #dcfce7; color: #16a34a; }
  &.status-failed { background: #fee2e2; color: #dc2626; }
  &.status-pending { background: #f1f5f9; color: #64748b; }
  &.status-sent { background: #dcfce7; color: #16a34a; }
}

.count-sent { color: #16a34a; font-weight: 600; }
.count-failed { color: #dc2626; font-weight: 600; }

/* Loading & Empty States */
.loading-state {
  text-align: center;
  padding: 3rem;
  color: #64748b;
  font-size: 1rem;

  i { margin-right: 0.5rem; }
}

.empty-state {
  text-align: center;
  padding: 3rem;

  h3 { color: #475569; margin-bottom: 0.5rem; }
  p { color: #94a3b8; }
}

.empty-icon {
  font-size: 3rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
  display: block;
}

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: white;
  border-radius: 0.75rem;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.modal-lg { max-width: 800px; }

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;

  h2 {
    font-size: 1.15rem;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i { color: #3b82f6; }
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem;

  &:hover { color: #1e293b; }
}

.modal-body { padding: 1.5rem; }

/* Detail Modal Stats */
.detail-summary {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.detail-stat {
  flex: 1;
  text-align: center;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;

  .stat-value {
    display: block;
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
  }

  .stat-label {
    display: block;
    font-size: 0.8rem;
    color: #64748b;
    margin-top: 0.25rem;
  }

  &.sent .stat-value { color: #16a34a; }
  &.failed .stat-value { color: #dc2626; }
}

.detail-recipients {
  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.75rem;
  }
}

.admin-table.compact {
  th, td { padding: 0.625rem 0.75rem; font-size: 0.825rem; }
}

/* Responsive */
@media (max-width: 768px) {
  .batch-email-container { padding: 1rem; }
  .page-header { flex-direction: column; align-items: flex-start; }
  .filter-row { flex-direction: column; }
  .filter-group { min-width: auto; }
  .step-indicators { flex-direction: column; }
  .step-label { display: none; }
  .review-summary { flex-direction: column; }
  .detail-summary { flex-direction: column; }
}
</style>
